module.exports = function() {
  return new Worker(__webpack_public_path__ + "2f6ec96fc704f66aecaa.worker.js");
};


// WEBPACK FOOTER //
// ./src/worker/read-xlsx.worker.js